<template>

  <div class="card_offer mb-0">
    <img
      class="card_offer__image"
      :src="urls[0]"
      v-if="urls[0]"
    >
    <img
      class="card_offer__image"
      src="@/assets/img/img-defecto.svg"
      v-else
    >

    <div class="card_offer__actions">
      <div class="actions_date" style="width: 70%">
        <img src="@/assets/img/icons/available-icon.svg" />
        <div class="actions_date__text">
          <div>Disponible hasta</div>
          <div class="actions_date__date" v-if="offer.attributes.expiration">{{offer.attributes.expiration}}</div>
          <div v-else class="actions_date__date">aaaa-mm-dd</div>
        </div>
      </div>
    </div>

    <div class="card_offer__body">
      <div class="card_offer__body--title">
        {{offer.attributes.title | capitalize}}
      </div>

      <div class="card_offer__body--subtitle">
        Descripción
      </div>
      <p class="card_offer__body--text" style="height: 230px;">{{offer.attributes.description}}</p>

      <div class="card_offer__body--subtitle">
        Términos y condiciones
      </div>
      <p class="card_offer__body--text" style="height: 230px;">{{offer.attributes.tc }}</p>

      <span class="card_offer__body--subtitle">Limite de canjes de la oferta</span>
      <p class="card_offer__body--text expiration">
        {{Number(offer.attributes.redeem_limit) >= 0 ? offer.attributes.redeem_limit : 'Sin limite'}}
      </p>

        <span class="card_offer__body--subtitle">Es visible para los usuarios</span>
        <p class="card_offer__body--text classes_quantity">
          {{offer.attributes.published == true ? 'Si' : 'No'}}
        </p>

        <span class="card_offer__body--subtitle">La oferta es reward</span>
        <p class="card_offer__body--text classes_quantity">
          {{offer.attributes.is_rewardable == true ? 'Si' : 'No'}}
        </p>

        <div class="data_card__info--container">
          <span class="card_offer__body--subtitle">Locaciones</span>
          <section class="data_card__info--trainers_container">
            <div
              class="data_card__info--trainer default_trainer"
              v-if="locations_selected.length <= 0">
            </div>
            <div
              class="data_card__info--trainer"
              v-else
              v-for="(trainer, index) in locations_selected"
              :key="index"
              :style="{backgroundImage: `url('${getImageServer() + trainer.attributes.image.thumb.url}')`}">
              <!--<div
                class="data_card__info--remove"
                @click="removeTrainer(index)">
                <img src="https://s3-us-west-2.amazonaws.com/karrottsportlife/cross.svg" alt="">
              </div>-->
            </div>
          </section>
        </div>
      </div>
  </div>

</template>

<script>
export default {
  props:{
    offer: Object,
    url_change: false,
    urls: Array,
    locations_selected: Array
  }
}
</script>

<style scoped>
  .card_offer__body--title{
    height: 120px;
    background: #EFF3F7 0% 0% no-repeat padding-box !important;
    border-radius: 10px;
    padding: 10px;
  }
  .card_offer__body--text{
    margin-bottom: 20px;
    background: #EFF3F7 0% 0% no-repeat padding-box !important;
    border-radius: 10px;
    padding: 10px;
  }

  .classes_quantity{
    width: 40px;
    text-align: center;
  }

  .data_card__info--trainer{
    border-radius: 50%;
    box-shadow: 0px 3px 6px #00000029;
  }
</style>





// WEBPACK FOOTER //
// src/components/shared/PreviewOffer.vue